/* Read-more / Read-less toggle for product descriptions */
document.addEventListener('DOMContentLoaded', () => {
  const wrap = document.querySelector('.js-readmore');
  if (!wrap) return;

  const preview = wrap.querySelector('.js-readmore-preview');
  const full    = wrap.querySelector('.js-readmore-full');
  const btn     = wrap.querySelector('.js-readmore-btn');

  // If description <= 100 words the preview == full, so no toggle needed
  if (!full || full.innerText.trim() === preview.innerText.trim()) {
    btn.style.display = 'none';
    return;
  }

  btn.addEventListener('click', () => {
    const expanded = btn.getAttribute('aria-expanded') === 'true';

    if (expanded) {
      // collapse to 100-word preview
      full.hidden    = true;
      preview.hidden = false;
      btn.textContent = 'Read more';
    } else {
      // expand to full description
      full.hidden    = false;
      preview.hidden = true;
      btn.textContent = 'Read less';
    }
    btn.setAttribute('aria-expanded', (!expanded).toString());
  });
});
